import React, { FC, useState, useEffect } from 'react';
import axios from '../../../sharedModules/utils/axios.utils';

import Button from '@mui/material/Button';

interface DownloadLogButtonProps {
  chillerId: string;
}

const DownloadLogButton: FC<DownloadLogButtonProps> = ({ chillerId }) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  const fetchPDF = async () => {
    try {
      const response: any = await axios.get(`/chiller_logs/chiller_pdfs/${chillerId}`);
      if (response.status === 200) {
        setPdfUrl(response.data.download_url);
      }
    } catch (error: any) {
      if (error.response?.status === 202) {
        console.log('PDF not ready yet.');
      } else {
        console.error('Error fetching PDF:', error);
      }
    }
  };

  useEffect(() => {
    if (chillerId) {
      fetchPDF();
    }
  }, [chillerId]);

  return (
    <>
      {pdfUrl && (
        <a href={pdfUrl} download target="_blank" rel="noopener noreferrer">
          <Button variant="contained">Print Log</Button>
        </a>
      )}
    </>
  );
};

export default DownloadLogButton;
